import { TreeContext } from "../../../utils/contexts";

import {
	ListItem,
	ListItemText,
	ListItemIcon,
	CircularProgress,
 } from "@mui/material";
import {
	Folder,
	FolderOpen,
	KeyboardArrowRight,
	KeyboardArrowDown,
 } from "@mui/icons-material";

import TreeRowChild from "./TreeRow";

class TreeRow extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			open:
				props.level === 0 ||
				Boolean(this.props.treeItems[this.props.item.nodeRef]),
		};
	}

	componentDidUpdate(oldProps) {
		if (
			!Boolean(oldProps.treeItems[oldProps.item.nodeRef]) &&
			Boolean(this.props.treeItems[this.props.item.nodeRef])
		) {
			this.setState({
				open: true,
			});
		}
	}

	onClick = async (event) => {
		event.preventDefault();

		const {
			item: { nodeRef },
			treeItems,
		} = this.props;

		const {
			fetchContent,
			fetchTreeChildren,
			breadcrumbs,
			fetchBreadcrumbs,
		} = this.context;

		const isCurrent = nodeRef === breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

		if (isCurrent) {
			this.setState((state) => ({ open: !state.open }));
		} else {
			await fetchContent(undefined, nodeRef, 1);
			fetchBreadcrumbs(nodeRef);

			if (!Boolean(treeItems[nodeRef])) {
				await fetchTreeChildren(nodeRef);
			}

			this.setState(() => ({ open: true }));
		}
	};

	handleHideFolder = (event) => {
		event && event.stopPropagation();
		this.setState(() => ({ open: false }));
	};

	handleShowFolder = async (event) => {
		event && event.stopPropagation();

		const {
			item: { nodeRef },
			treeItems,
		} = this.props;

		const { fetchTreeChildren } = this.context;

		if (!Boolean(treeItems[nodeRef])) {
			await fetchTreeChildren(nodeRef);
		}

		this.setState(() => ({ open: true }));
	};

	render() {
		const {
			item: { nodeRef, hasChildren, name },
			level,
			isHidden,
			treeItems,
		} = this.props;

		const { open } = this.state;
		const { breadcrumbs, loadingItem } = this.context;

		const children = treeItems[nodeRef] || [];
		const display = isHidden ? "none" : "block";
		const isCurrent = breadcrumbs[breadcrumbs.length - 1]?.nodeRef === nodeRef;

		return (
			<div
				style={{
					marginLeft: level === 0 ? 0 : hasChildren ? "1rem" : "2.18rem",
					display,
				}}
			>
				<ListItem
					onClick={Boolean(loadingItem) ? null : this.onClick}
					sx={{
						paddingLeft: 0,
						paddingTop: "5px",
						paddingBottom: "5px",
						width: "calc(300px + 0.5rem)",
					}}
					button
				>
					<ListItemIcon
						sx={{
							minWidth: 0,
							marginRight: "5px",
							alignItems: "center",
						}}
					>
						{hasChildren && !open && (
							<KeyboardArrowRight
								onClick={
									Boolean(loadingItem) ? null : this.handleShowFolder
								}
								fontSize="small"
							/>
						)}
						{hasChildren && open && (
							<KeyboardArrowDown
								onClick={
									Boolean(loadingItem) ? null : this.handleHideFolder
								}
								fontSize="small"
							/>
						)}
						{loadingItem === nodeRef && <CircularProgress size="13px" />}
						{loadingItem !== nodeRef && isCurrent && (
							<Folder
								color="primary"
								fontSize="small"
								sx={{
									...(hasChildren
										? {}
										: { marginLeft: "0.1rem" }),
								}}
							/>
						)}
						{loadingItem !== nodeRef && !isCurrent && (
							<FolderOpen
								color="primary"
								fontSize="small"
								sx={{
									...(hasChildren
										? {}
										: { marginLeft: "0.1rem" }),
								}}
							/>
						)}
					</ListItemIcon>
					<ListItemText
						sx={{
							fontSize: "13px",
							wordBreak: "break-all",
						}}
						disableTypography
					>
						{name}
					</ListItemText>
				</ListItem>
				{children &&
					children.map((it, index) => (
						<TreeRowChild
							key={index}
							item={it}
							level={level + 1}
							isHidden={!open}
							treeItems={treeItems}
						/>
					))}
			</div>
		);
	}
}

TreeRow.contextType = TreeContext;

export default TreeRow;
